import SelectCategories from './SelectCategories';

export default SelectCategories;
